import React from 'react';

/**
 * Icons shared between the detail modal and its sections.
 *
 * Only the ones with more than one caller live here: `DownloadIcon` is used by
 * the modal's download row and by every release-history row. The modal's own
 * link and close glyphs stay with the modal, as the lightbox's do with the
 * lightbox.
 */
export function DownloadIcon() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="7 10 12 15 17 10" />
      <line x1="12" y1="15" x2="12" y2="3" />
    </svg>
  );
}
